module.exports = __webpack_public_path__ + "img/rand_money.dd30c7f9.svg";